import { memo, useCallback } from 'react';

import { Field } from './field';
import { FieldItemProps } from './types';

export const FieldItem = memo(
  ({ index, onRemove, ...rest }: FieldItemProps) => {
    const handleRemove = useCallback(() => onRemove(index), [index, onRemove]);
    return <Field {...rest} onRemove={handleRemove} />;
  }
);

FieldItem.displayName = 'FieldItem';
